export const Options = [
    {
        value: 'NOT_APPLICABLE',
        label: 'Não aplica',
        score: undefined
    },
    {
        value: 'DONT_KNOW',
        label: 'Não sei',
        score: 0
    },
    {
        value: 'NO',
        label: 'Não',
        score: 1
    },
    {
        value: 'PARCIALLY',
        label: 'Sim, parcialmente',
        score: 3
    },
    {
        value: 'SIGNIFICANTLY',
        label: 'Sim, de forma significativa',
        score: 5
    },
]

export const MAX_SCORE = Options.slice(-1)[0].score

export const EXCLUDE_VALUE = Options[0].value

export const scaleValueEntailsAction = (scaleValue) => ['DONT_KNOW', 'NO'].includes(scaleValue)

export const randomResponse = () => Options[Math.floor(Math.random()*Options.length)].value;


// WEBPACK FOOTER //
// ./src/scales.js